import type { ShippingAddress } from '~/api/types';
import { TextField } from './TextField';

interface AddressConfigProps {
  name: string;
  shippingAddress: ShippingAddress;
  onChange: (address: ShippingAddress) => void;
}

const fields = [
  { key: 'city', id: 'city', label: 'City' },
  { key: 'country', id: 'country', label: 'Country code' },
  { key: 'postal_code', id: 'postal-code', label: 'Postal code' },
  { key: 'street_address', id: 'street-address', label: 'Street address' },
] as const;

export function AddressConfig({
  name,
  shippingAddress,
  onChange,
}: AddressConfigProps) {
  return (
    <div className="flex w-full flex-col gap-4">
      {fields.map(({ key, id, label }) => (
        <TextField
          key={key}
          id={`${name}-${id}`}
          label={label}
          value={shippingAddress[key]}
          onChange={(value) => onChange({ ...shippingAddress, [key]: value })}
        />
      ))}
    </div>
  );
}
